import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { useField } from "formik";
import React, { useEffect, useState } from "react";
import { IconChevronDown } from "../svg";

const InputDatepickerField = ({
  label,
  view = "date",
  shrinkLabel = true,
  classes = {},
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setSelectedDate(field.value);

  }, [field.value]);

  const getFormat = (val) => {
    if (val === "month") {
      return "MMMM";
    }
    if (val === "year") {
      return "yyyy";
    }
    return "dd.MM.yyyy";
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    helpers.setValue(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={`date-time-picker`}
        autoOk
        disabled={props.disabled || false}
        disableToolbar
        variant="inline"
        inputVariant="outlined"
        format={getFormat(view)}
        margin="normal"
        label={label || null}
        value={selectedDate}
        onChange={handleDateChange}
        placeholder={'dd.MM.yyyy'}
        KeyboardButtonProps={{
          "aria-label": "change date",
          // className: "pl-0 pr-0 svg-size-xs",
        }}
        InputProps={{
          classes: classes,
        }}
        InputLabelProps={{
          shrink: shrinkLabel,
        }}
        PopoverProps={{
          classes: {
            paper: `${view === "year" ? "date-time-picker-yearly" : null}`,
          },
        }}
        views={[`${view}`]}
        openTo={`${view}`}
        keyboardIcon={props.keyboardIcon ? props.keyboardIcon : <IconChevronDown />}
        helperText={meta.touched && meta.error ? meta.error : null}
        error={meta.touched && meta.error ? true : false}
        {...props}
        name={field.name}
      />
    </MuiPickersUtilsProvider>
  );
};

export default InputDatepickerField;
